const { sha256 } = require("js-sha256");

export const sha256Hash = (string) => sha256(string);
